module.exports = "//static.hsappstatic.net/salesImages/static-1.403/email-images/green_check.png"